// extracted by mini-css-extract-plugin
module.exports = {"title":"auditTrail_title__27hRA"};